// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__Dj7l8","buttonText":"styles_buttonText__Xnro_","fileIcon":"styles_fileIcon__RagIG","card":"styles_card__BPwHy","cardHeader":"styles_cardHeader__XpM79"};